// extracted by mini-css-extract-plugin
export default {"-large":"suboption-module__-large--fmMdV","container":"suboption-module__container--IC2mQ"};